import _ from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Fields } from 'redux-form';
import { isTestEnv } from '../../../../devOpsHelper/DevOps';
import AutoCompany from '../../../../forms/autoCompany/AutoCompany';
import {
    REQUEST_COMPANY_LOOKUP,
    TOGGLE_MANUAL_COMPANY_STATE
} from '../CompanyDetails.actions';
import { ManualCompany } from './ManualCompany';
import styles from '../CompanyDetails.module.css';

const mapStateToProps = ({ profile }) => ({
    ...profile
});

const mapDispatchToProps = (dispatch) => ({
    fetchCompanies: (company) =>
        dispatch({ type: REQUEST_COMPANY_LOOKUP, company }),
    toggleManualCompanyState: () =>
        dispatch({ type: TOGGLE_MANUAL_COMPANY_STATE })
});

class CompanyNameQuestion extends Component {
    constructor(props) {
        super(props);

        if (isTestEnv()) {
            this.onCompanyNameChange = this.props.fetchCompanies;
        } else {
            this.onCompanyNameChange = _.debounce(
                this.props.fetchCompanies,
                500
            );
        }
    }

    renderCompanyQuestion = (fieldProps) => {
        const {
            companies,
            showManualCompany,
            fetchCompaniesPending,
            onChangePrompt
        } = this.props;

        if (!showManualCompany) {
            return (
                <AutoCompany
                    onChange={this.onCompanyNameChange}
                    onChangePrompt={onChangePrompt}
                    companies={companies}
                    fetchCompaniesPending={fetchCompaniesPending}
                    toggleManualCompanyState={
                        this.props.toggleManualCompanyState
                    }
                    {...this.props}
                    {...fieldProps}
                />
            );
        } else {
            return (
                <ManualCompany
                    onChangePrompt={onChangePrompt}
                    {...this.props}
                    {...fieldProps}
                />
            );
        }
    };

    render() {
        return (
            <div className={styles.CompanyName} data-testid="companyName">
                <Fields
                    names={['companyName', 'companyNumber']}
                    component={this.renderCompanyQuestion}
                    {...this.props}
                />
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyNameQuestion);
